// extracted by mini-css-extract-plugin
export default {"fg-1":"items_fg-1__4DJWb","item-paper":"items_item-paper__ItVEc","item-photo":"items_item-photo__y-sny","item-thumbnail":"items_item-thumbnail__TiNMr"};